export const CAPRINI_RISK_ASSESSMENT = {
  masterTableName: "MC_CAPRINI_RISK_ASSESSMENT",
  tableName: "MC_CAPRINI_RISK_ASSESSMENT_DET",
  columnName: "CRA_ID",
  columnValue: 0,
  title: "caprini-risk-assessment.title",
  rows: [
    { title: "id", value: "ID", headerName: "ID" },
    { title: "date", value: "PROCESS_TIME", headerName: "Tarih" },
    { title: "AGE", value: "AGE_XNAME" },
    { title: "MINOR_SURGERY", value: "MINOR_SURGERY_XNAME" },
    { title: "MAJOR_SURGERY_HISTORY", value: "MAJOR_SURGERY_HISTORY_XNAME" },
    {
      title: "INFLAMMATORY_BOWEL_DISEASE",
      value: "INFLAMMATORY_BOWEL_DISE_XNAME",
    },
    { title: "OBESITY", value: "OBESITY_XNAME" },
    { title: "LEG_SWELLING_PRESENCE", value: "LEG_SWELLING_PRESENCE_XNAME" },
    {
      title: "ACUTE_MYOCARDIAL_INFECTION",
      value: "ACUTE_MYOCARDIAL_INFECT_XNAME",
    },
    {
      title: "CONJUNCTIVE_HEART_FAILURE",
      value: "CONJUNCTIVE_HEART_FAILU_XNAME",
    },
    { title: "VARICOSE_VEINS", value: "VARICOSE_VEINS_XNAME" },
    { title: "SEPSIS", value: "SEPSIS_XNAME" },
    { title: "PNEUMONIA", value: "PNEUMONIA_XNAME" },
    {
      title: "ABNORMAL_BREATHING_TEST",
      value: "ABNORMAL_BREATHING_TEST_XNAME",
    },
    {
      title: "BEDRIDDEN_MEDICAL_PATIENT",
      value: "BEDRIDDEN_MEDICAL_PATIE_XNAME",
    },
    { title: "POST_BIRTH", value: "POST_BIRTH_XNAME" },
    {
      title: "ORAL_CONTRACEPTIVE_REPLACEMENT",
      value: "ORAL_CONTRACEPTIVE_REPL_XNAME",
    },
    {
      title: "REPETITIVE_SPONTANEOUS",
      value: "REPETITIVE_SPONTANEOUS_XNAME",
    },
    { title: "ARTHROSCOPIC_SURGERY", value: "ARTHROSCOPIC_SURGERY_XNAME" },
    { title: "MAJOR_OPEN_SURGERY", value: "MAJOR_OPEN_SURGERY_XNAME" },
    { title: "LAPAROSCOPIC_SURGERY", value: "LAPAROSCOPIC_SURGERY_XNAME" },
    { title: "BEDRIDDEN_PATIENT", value: "BEDRIDDEN_PATIENT_XNAME" },
    {
      title: "IMMOBILIZATION_TO_PLASTER",
      value: "IMMOBILIZATION_TO_PLAST_XNAME",
    },
    {
      title: "CENTRAL_VENOUS_CATHETER",
      value: "CENTRAL_VENOUS_CATHETER_XNAME",
    },
    { title: "VTE_HISTORY", value: "VTE_HISTORY_XNAME" },
    { title: "VTE_FAMILY_HISTORY", value: "VTE_FAMILY_HISTORY_XNAME" },
    {
      title: "FACTOR_V_LEIDEN_MUTATION",
      value: "FACTOR_V_LEIDEN_MUTATIO_XNAME",
    },
    { title: "PROTHROMBINE", value: "PROTHROMBINE_XNAME" },
    { title: "LUPUS_ANTICOAGULANTS", value: "LUPUS_ANTICOAGULANTS_XNAME" },
    {
      title: "ANTICARDIOLIPIN_ANTIBODIES",
      value: "ANTICARDIOLIPIN_ANTIBOD_XNAME",
    },
    { title: "HIGH_HOMOCYSTEINE", value: "HIGH_HOMOCYSTEINE_XNAME" },
    { title: "STROKE", value: "STROKE_XNAME" },
    { title: "MULTIPL_TRAUMA", value: "MULTIPL_TRAUMA_XNAME" },
    {
      title: "ACUTE_SPINAL_CORD_INJURY",
      value: "ACUTE_SPINAL_CORD_INJUR_XNAME",
    },
    {
      title: "HPN_INDUCED_THROMBOCYTOPENIA",
      value: "HPN_INDUCED_THROMBOCYTO_XNAME",
    },
    { title: "OTHER_THROMBOPHILIAS", value: "OTHER_THROMBOPHILIAS_XNAME" },
    {
      title: "ELTF_MJR_EXMY_ARTHROPLASTY",
      value: "ELTF_MJR_EXMY_ARTHROPLA_XNAME",
    },
    {
      title: "HP_PELVIS_LEG_FRACTURE",
      value: "HP_PELVIS_LEG_FRACTURE_XNAME",
    },
    { title: "CANCER", value: "CANCER_XNAME" },
    { title: "CALC_VALUE", value: "CALC_VALUE" },
  ],
  fields: [
    { field: "id", headerName: "ID", flex: 1 },
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "AGE", headerName: "caprini-risk-assessment.age", flex: 1 },
    {
      field: "MINOR_SURGERY",
      headerName: "caprini-risk-assessment.minor-surgery",
      flex: 1,
    },
    {
      field: "MAJOR_SURGERY_HISTORY",
      headerName:
        "caprini-risk-assessment.major-surgery-history-less-than-1-month",
      flex: 1,
    },
    {
      field: "INFLAMMATORY_BOWEL_DISEASE",
      headerName:
        "caprini-risk-assessment.inflammatory-bowel-disease-history",
      flex: 1,
    },
    {
      field: "OBESITY",
      headerName: "caprini-risk-assessment.obesity-bmi-over-25",
      flex: 1,
    },
    {
      field: "LEG_SWELLING_PRESENCE",
      headerName: "caprini-risk-assessment.leg-swelling",
      flex: 1,
    },
    {
      field: "ACUTE_MYOCARDIAL_INFECTION",
      headerName: "caprini-risk-assessment.acute-myocardial-infarction",
      flex: 1,
    },
    {
      field: "CONJUNCTIVE_HEART_FAILURE",
      headerName:
        "caprini-risk-assessment.congestive-heart-failure-less-than-1-month",
      flex: 1,
    },
    {
      field: "VARICOSE_VEINS",
      headerName: "caprini-risk-assessment.varicose-veins",
      flex: 1,
    },
    {
      field: "SEPSIS",
      headerName: "caprini-risk-assessment.sepsis-less-than-1-month",
      flex: 1,
    },
    {
      field: "PNEUMONIA",
      headerName: "caprini-risk-assessment.pneumonia",
      flex: 1,
    },
    {
      field: "ABNORMAL_BREATHING_TEST",
      headerName: "caprini-risk-assessment.abnormal-respiratory-test-copd",
      flex: 1,
    },
    {
      field: "BEDRIDDEN_MEDICAL_PATIENT",
      headerName: "caprini-risk-assessment.bedridden-medical-patient",
      flex: 1,
    },
    {
      field: "POST_BIRTH",
      headerName: "caprini-risk-assessment.post-birth",
      flex: 1,
    },
    {
      field: "ORAL_CONTRACEPTIVE_REPLACEMENT",
      headerName: "caprini-risk-assessment.oral-contraceptive-replacement",
      flex: 1,
    },
    {
      field: "REPETITIVE_SPONTANEOUS",
      headerName: "caprini-risk-assessment.repetitive-spontaneous",
      flex: 1,
    },
    {
      field: "ARTHROSCOPIC_SURGERY",
      headerName: "caprini-risk-assessment.arthroscopic-surgery",
      flex: 1,
    },
    {
      field: "MAJOR_OPEN_SURGERY",
      headerName: "caprini-risk-assessment.major-open-surgery",
      flex: 1,
    },
    {
      field: "LAPAROSCOPIC_SURGERY",
      headerName:
        "caprini-risk-assessment.laparoscopic-surgery-over-45-minutes",
      flex: 1,
    },
    {
      field: "BEDRIDDEN_PATIENT",
      headerName: "caprini-risk-assessment.bedridden-patient-over-72-hours",
      flex: 1,
    },
    {
      field: "IMMOBILIZATION_TO_PLASTER",
      headerName: "caprini-risk-assessment.immobilization-due-to-cast",
      flex: 1,
    },
    {
      field: "CENTRAL_VENOUS_CATHETER",
      headerName: "caprini-risk-assessment.central-venous-catheter",
      flex: 1,
    },
    {
      field: "VTE_HISTORY",
      headerName: "caprini-risk-assessment.vte-history",
      flex: 1,
    },
    {
      field: "VTE_FAMILY_HISTORY",
      headerName: "caprini-risk-assessment.vte-family-history",
      flex: 1,
    },
    {
      field: "FACTOR_V_LEIDEN_MUTATION",
      headerName: "caprini-risk-assessment.factor-v-leiden-mutation",
      flex: 1,
    },
    {
      field: "PROTHROMBINE",
      headerName: "caprini-risk-assessment.prothrombin-20210a",
      flex: 1,
    },
    {
      field: "LUPUS_ANTICOAGULANTS",
      headerName: "caprini-risk-assessment.lupus-anticoagulants",
      flex: 1,
    },
    {
      field: "ANTICARDIOLIPIN_ANTIBODIES",
      headerName: "caprini-risk-assessment.anticardiolipin-antibodies",
      flex: 1,
    },
    {
      field: "HIGH_HOMOCYSTEINE",
      headerName: "caprini-risk-assessment.high-homocysteine",
      flex: 1,
    },
    {
      field: "STROKE",
      headerName: "caprini-risk-assessment.stroke-over-1-month",
      flex: 1,
    },
    {
      field: "MULTIPL_TRAUMA",
      headerName: "caprini-risk-assessment.multiple-trauma-less-than-1-month",
      flex: 1,
    },
    {
      field: "ACUTE_SPINAL_CORD_INJURY",
      headerName:
        "caprini-risk-assessment.acute-spinal-cord-injury-less-than-1-month",
      flex: 1,
    },
    {
      field: "HPN_INDUCED_THROMBOCYTOPENIA",
      headerName: "caprini-risk-assessment.heparin-induced-thrombocytopenia",
      flex: 1,
    },
    {
      field: "OTHER_THROMBOPHILIAS",
      headerName: "caprini-risk-assessment.other-thrombophilias",
      flex: 1,
    },
    {
      field: "ELTF_MJR_EXMY_ARTHROPLASTY",
      headerName:
        "caprini-risk-assessment.elective-major-lower-extremity-arthroplasty",
      flex: 1,
    },
    {
      field: "HP_PELVIS_LEG_FRACTURE",
      headerName: "caprini-risk-assessment.hip-pelvis-or-leg-fracture",
      flex: 1,
    },
    {
      field: "CANCER",
      headerName: "caprini-risk-assessment.cancer",
      flex: 1,
    },
    {
      field: "CALC_VALUE",
      headerName: "caprini-risk-assessment.score",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        if (!row) return 0;
        const age = Number(row.AGE_XVALUE) || 0;
        const minorsurgery = Number(row.MINOR_SURGERY_XVALUE) || 0;
        const majorsurgeryhistory =
          Number(row.MAJOR_SURGERY_HISTORY_XVALUE) || 0;
        const inflammatoryboweldisease =
          Number(row.INFLAMMATORY_BOWEL_DISE_XVALUE) || 0;
        const obesity = Number(row.OBESITY_XVALUE) || 0;
        const legswellingpresence =
          Number(row.LEG_SWELLING_PRESENCE_XVALUE) || 0;
        const abnormalbreathingtest =
          Number(row.ABNORMAL_BREATHING_TEST_XVALUE) || 0;
        const acutemyocardialinfection =
          Number(row.ACUTE_MYOCARDIAL_INFECT_XVALUE) || 0;
        const conjunctiveheartfailure =
          Number(row.CONJUNCTIVE_HEART_FAILU_XVALUE) || 0;
        const varicoseveins = Number(row.VARICOSE_VEINS_XVALUE) || 0;
        const sepsis = Number(row.SEPSIS_XVALUE) || 0;
        const pneumonia = Number(row.PNEUMONIA_XVALUE) || 0;
        const bedriddenmedicalpatient =
          Number(row.BEDRIDDEN_MEDICAL_PATIE_XVALUE) || 0;
        const postbirth = Number(row.POST_BIRTH_XVALUE) || 0;
        const oralcontraceptivereplacement =
          Number(row.ORAL_CONTRACEPTIVE_REPL_XVALUE) || 0;
        const repetitivespontaneous =
          Number(row.REPETITIVE_SPONTANEOUS_XVALUE) || 0;
        const arthroscopicsurgery =
          Number(row.ARTHROSCOPIC_SURGERY_XVALUE) || 0;
        const majoropensurgery = Number(row.MAJOR_OPEN_SURGERY_XVALUE) || 0;
        const laparoscopicsurgery =
          Number(row.LAPAROSCOPIC_SURGERY_XVALUE) || 0;
        const bedriddenpatient = Number(row.BEDRIDDEN_PATIENT_XVALUE) || 0;
        const immobilizationtoplaster =
          Number(row.IMMOBILIZATION_TO_PLAST_XVALUE) || 0;
        const centralvenouscatheter =
          Number(row.CENTRAL_VENOUS_CATHETER_XVALUE) || 0;
        const vtehistory = Number(row.VTE_HISTORY_XVALUE) || 0;
        const vtefamilyhistory = Number(row.VTE_FAMILY_HISTORY_XVALUE) || 0;
        const factorvleidenmutation =
          Number(row.FACTOR_V_LEIDEN_MUTATIO_XVALUE) || 0;
        const prothrombine = Number(row.PROTHROMBINE_XVALUE) || 0;
        const lupusanticoagulants =
          Number(row.LUPUS_ANTICOAGULANTS_XVALUE) || 0;
        const anticardiolipinantibodies =
          Number(row.ANTICARDIOLIPIN_ANTIBOD_XVALUE) || 0;
        const highhomocysteine = Number(row.HIGH_HOMOCYSTEINE_XVALUE) || 0;
        const hpninducedthrombopenia =
          Number(row.HPN_INDUCED_THROMBOCYTO_XVALUE) || 0;
        const otherthrombophilias =
          Number(row.OTHER_THROMBOPHILIAS_XVALUE) || 0;
        const acutespinalcordinjury =
          Number(row.ACUTE_SPINAL_CORD_INJUR_XVALUE) || 0;
        const stroke = Number(row.STROKE_XVALUE) || 0;
        const eltfmjrexmyarthroplasty =
          Number(row.ELTF_MJR_EXMY_ARTHROPLA_XVALUE) || 0;
        const hppelvislegfracture =
          Number(row.HP_PELVIS_LEG_FRACTURE_XVALUE) || 0;
        const multipltrauma = Number(row.MULTIPL_TRAUMA_XVALUE) || 0;
        const cancer = Number(row.CANCER_XVALUE) || 0;

        const totalScore =
          age +
          minorsurgery +
          majorsurgeryhistory +
          inflammatoryboweldisease +
          obesity +
          legswellingpresence +
          abnormalbreathingtest +
          acutemyocardialinfection +
          conjunctiveheartfailure +
          varicoseveins +
          sepsis +
          pneumonia +
          bedriddenmedicalpatient +
          postbirth +
          repetitivespontaneous +
          oralcontraceptivereplacement +
          arthroscopicsurgery +
          majoropensurgery +
          laparoscopicsurgery +
          bedriddenpatient +
          immobilizationtoplaster +
          centralvenouscatheter +
          vtehistory +
          vtefamilyhistory +
          factorvleidenmutation +
          prothrombine +
          lupusanticoagulants +
          anticardiolipinantibodies +
          highhomocysteine +
          hpninducedthrombopenia +
          otherthrombophilias +
          acutespinalcordinjury +
          stroke +
          eltfmjrexmyarthroplasty +
          hppelvislegfracture +
          multipltrauma +
          cancer;
        return totalScore;
      },
    },
  ],
  mcpConfig: {
    AGE: { mcpId: 687, field: "AGE", scoreField: "AGE_XVALUE" },
    MINOR_SURGERY: {
      mcpId: 688,
      field: "MINOR_SURGERY",
      scoreField: "MINOR_SURGERY_XVALUE",
    },
    MAJOR_SURGERY_HISTORY: {
      mcpId: 689,
      field: "MAJOR_SURGERY_HISTORY",
      scoreField: "MAJOR_SURGERY_HISTORY_XVALUE",
    },
    INFLAMMATORY_BOWEL_DISEASE: {
      mcpId: 690,
      field: "INFLAMMATORY_BOWEL_DISEASE",
      scoreField: "INFLAMMATORY_BOWEL_DISE_XVALUE",
    },
    OBESITY: { mcpId: 691, field: "OBESITY", scoreField: "OBESITY_XVALUE" },
    LEG_SWELLING_PRESENCE: {
      mcpId: 692,
      field: "LEG_SWELLING_PRESENCE",
      scoreField: "LEG_SWELLING_PRESENCE_XVALUE",
    },
    ACUTE_MYOCARDIAL_INFECTION: {
      mcpId: 693,
      field: "ACUTE_MYOCARDIAL_INFECTION",
      scoreField: "ACUTE_MYOCARDIAL_INFECT_XVALUE",
    },
    CONJUNCTIVE_HEART_FAILURE: {
      mcpId: 694,
      field: "CONJUNCTIVE_HEART_FAILURE",
      scoreField: "CONJUNCTIVE_HEART_FAILU_XVALUE",
    },
    VARICOSE_VEINS: {
      mcpId: 695,
      field: "VARICOSE_VEINS",
      scoreField: "VARICOSE_VEINS_XVALUE",
    },
    SEPSIS: { mcpId: 696, field: "SEPSIS", scoreField: "SEPSIS_XVALUE" },
    PNEUMONIA: {
      mcpId: 697,
      field: "PNEUMONIA",
      scoreField: "PNEUMONIA_XVALUE",
    },
    ABNORMAL_BREATHING_TEST: {
      mcpId: 698,
      field: "ABNORMAL_BREATHING_TEST",
      scoreField: "ABNORMAL_BREATHING_TEST_XVALUE",
    },
    BEDRIDDEN_MEDICAL_PATIENT: {
      mcpId: 699,
      field: "BEDRIDDEN_MEDICAL_PATIENT",
      scoreField: "BEDRIDDEN_MEDICAL_PATIE_XVALUE",
    },
    POST_BIRTH: {
      mcpId: 700,
      field: "POST_BIRTH",
      scoreField: "POST_BIRTH_XVALUE",
    },
    ORAL_CONTRACEPTIVE_REPLACEMENT: {
      mcpId: 701,
      field: "ORAL_CONTRACEPTIVE_REPLACEMENT",
      scoreField: "ORAL_CONTRACEPTIVE_REPL_XVALUE",
    },
    REPETITIVE_SPONTANEOUS: {
      mcpId: 702,
      field: "REPETITIVE_SPONTANEOUS",
      scoreField: "REPETITIVE_SPONTANEOUS_XVALUE",
    },
    ARTHROSCOPIC_SURGERY: {
      mcpId: 703,
      field: "ARTHROSCOPIC_SURGERY",
      scoreField: "ARTHROSCOPIC_SURGERY_XVALUE",
    },
    MAJOR_OPEN_SURGERY: {
      mcpId: 704,
      field: "MAJOR_OPEN_SURGERY",
      scoreField: "MAJOR_OPEN_SURGERY_XVALUE",
    },
    LAPAROSCOPIC_SURGERY: {
      mcpId: 705,
      field: "LAPAROSCOPIC_SURGERY",
      scoreField: "LAPAROSCOPIC_SURGERY_XVALUE",
    },
    BEDRIDDEN_PATIENT: {
      mcpId: 706,
      field: "BEDRIDDEN_PATIENT",
      scoreField: "BEDRIDDEN_PATIENT_XVALUE",
    },
    IMMOBILIZATION_TO_PLASTER: {
      mcpId: 707,
      field: "IMMOBILIZATION_TO_PLASTER",
      scoreField: "IMMOBILIZATION_TO_PLAST_XVALUE",
    },
    CENTRAL_VENOUS_CATHETER: {
      mcpId: 708,
      field: "CENTRAL_VENOUS_CATHETER",
      scoreField: "CENTRAL_VENOUS_CATHETER_XVALUE",
    },
    VTE_HISTORY: {
      mcpId: 709,
      field: "VTE_HISTORY",
      scoreField: "VTE_HISTORY_XVALUE",
    },
    VTE_FAMILY_HISTORY: {
      mcpId: 710,
      field: "VTE_FAMILY_HISTORY",
      scoreField: "VTE_FAMILY_HISTORY_XVALUE",
    },
    FACTOR_V_LEIDEN_MUTATION: {
      mcpId: 711,
      field: "FACTOR_V_LEIDEN_MUTATION",
      scoreField: "FACTOR_V_LEIDEN_MUTATIO_XVALUE",
    },
    PROTHROMBINE: {
      mcpId: 712,
      field: "PROTHROMBINE",
      scoreField: "PROTHROMBINE_XVALUE",
    },
    LUPUS_ANTICOAGULANTS: {
      mcpId: 713,
      field: "LUPUS_ANTICOAGULANTS",
      scoreField: "LUPUS_ANTICOAGULANTS_XVALUE",
    },
    ANTICARDIOLIPIN_ANTIBODIES: {
      mcpId: 714,
      field: "ANTICARDIOLIPIN_ANTIBODIES",
      scoreField: "ANTICARDIOLIPIN_ANTIBOD_XVALUE",
    },
    HIGH_HOMOCYSTEINE: {
      mcpId: 715,
      field: "HIGH_HOMOCYSTEINE",
      scoreField: "HIGH_HOMOCYSTEINE_XVALUE",
    },
    STROKE: { mcpId: 716, field: "STROKE", scoreField: "STROKE_XVALUE" },
    MULTIPL_TRAUMA: {
      mcpId: 717,
      field: "MULTIPL_TRAUMA",
      scoreField: "MULTIPL_TRAUMA_XVALUE",
    },
    ACUTE_SPINAL_CORD_INJURY: {
      mcpId: 718,
      field: "ACUTE_SPINAL_CORD_INJURY",
      scoreField: "ACUTE_SPINAL_CORD_INJUR_XVALUE",
    },
    HPN_INDUCED_THROMBOCYTOPENIA: {
      mcpId: 719,
      field: "HPN_INDUCED_THROMBOCYTOPENIA",
      scoreField: "HPN_INDUCED_THROMBOCYTO_XVALUE",
    },
    OTHER_THROMBOPHILIAS: {
      mcpId: 720,
      field: "OTHER_THROMBOPHILIAS",
      scoreField: "OTHER_THROMBOPHILIAS_XVALUE",
    },
    ELTF_MJR_EXMY_ARTHROPLASTY: {
      mcpId: 721,
      field: "ELTF_MJR_EXMY_ARTHROPLASTY",
      scoreField: "ELTF_MJR_EXMY_ARTHROPLA_XVALUE",
    },
    HP_PELVIS_LEG_FRACTURE: {
      mcpId: 722,
      field: "HP_PELVIS_LEG_FRACTURE",
      scoreField: "HP_PELVIS_LEG_FRACTURE_XVALUE",
    },
    CANCER: { mcpId: 723, field: "CANCER", scoreField: "CANCER_XVALUE" },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    CRA_ID: "",
    CTIME: new Date(),
    PROCESS_TIME: new Date(),
    CUSER: "",
    AGE: "",
    MINOR_SURGERY: "",
    MAJOR_SURGERY_HISTORY: "",
    INFLAMMATORY_BOWEL_DISEASE: "",
    OBESITY: "",
    LEG_SWELLING_PRESENCE: "",
    ACUTE_MYOCARDIAL_INFECTION: "",
    CONJUNCTIVE_HEART_FAILURE: "",
    VARICOSE_VEINS: "",
    SEPSIS: "",
    PNEUMONIA: "",
    ABNORMAL_BREATHING_TEST: "",
    BEDRIDDEN_MEDICAL_PATIENT: "",
    POST_BIRTH: "",
    ORAL_CONTRACEPTIVE_REPLACEMENT: "",
    REPETITIVE_SPONTANEOUS: "",
    ARTHROSCOPIC_SURGERY: "",
    MAJOR_OPEN_SURGERY: "",
    LAPAROSCOPIC_SURGERY: "",
    BEDRIDDEN_PATIENT: "",
    IMMOBILIZATION_TO_PLASTER: "",
    CENTRAL_VENOUS_CATHETER: "",
    VTE_HISTORY: "",
    VTE_FAMILY_HISTORY: "",
    FACTOR_V_LEIDEN_MUTATION: "",
    PROTHROMBINE: "",
    LUPUS_ANTICOAGULANTS: "",
    ANTICARDIOLIPIN_ANTIBODIES: "",
    HIGH_HOMOCYSTEINE: "",
    STROKE: "",
    MULTIPL_TRAUMA: "",
    ACUTE_SPINAL_CORD_INJURY: "",
    HPN_INDUCED_THROMBOCYTOPENIA: "",
    OTHER_THROMBOPHILIAS: "",
    ELTF_MJR_EXMY_ARTHROPLASTY: "",
    HP_PELVIS_LEG_FRACTURE: "",
    CANCER: "",
    CALC_VALUE: "",
  },
  chartScoreField: "CALC_VALUE",
  chartTimeField: "PROCESS_TIME",
};
